import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { SasStationChangePasswordSentComponent } from './sas-station-change-password-sent/sas-station-change-password-sent.component';
import { SasStationForgotPasswordComponent } from './sas-station-forgot-password/sas-station-forgot-password.component';
import { SasStationInputComponent } from './sas-station-input/sas-station-input.component';
import { SasStationLoginComponent } from './sas-station-login/sas-station-login.component';
import { SasStationOemHeaderComponent } from './sas-station-oem-header/sas-station-oem-header.component';
import { SasStationOemLoginMessageComponent } from './sas-station-oem-login-message/sas-station-oem-login-message.component';
import { SasStationOemRegisterMessageComponent } from './sas-station-oem-register-message/sas-station-oem-register-message.component';
import { SasStationPasswordInputComponent } from './sas-station-password-input/sas-station-password-input.component';
import { SasStationRegisterResendComponent } from './sas-station-register-resend/sas-station-register-resend.component';
import { SasStationRegisterSendComponent } from './sas-station-register-send/sas-station-register-send.component';
import { SasStationRegisterComponent } from './sas-station-register/sas-station-register.component';
import { SasStationResetPasswordComponent } from './sas-station-reset-password/sas-station-reset-password.component';
import { SasStationUnblockComponent } from './sas-station-unblock/sas-station-unblock.component';
import { SasStationComponent } from './sas-station/sas-station.component';

@NgModule({
  declarations: [
    SasStationComponent,
    SasStationLoginComponent,
    SasStationRegisterComponent,
    SasStationUnblockComponent,
    SasStationRegisterResendComponent,
    SasStationRegisterSendComponent,
    SasStationForgotPasswordComponent,
    SasStationResetPasswordComponent,
    SasStationChangePasswordSentComponent,
    SasStationInputComponent,
    SasStationPasswordInputComponent,
    SasStationOemHeaderComponent,
    SasStationOemRegisterMessageComponent,
    SasStationOemLoginMessageComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    SasStationResetPasswordComponent,
    SasStationComponent,
    SasStationRegisterResendComponent,
    SasStationRegisterSendComponent,
    SasStationUnblockComponent,
    SasStationChangePasswordSentComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SasStationModule { }
